import React, { useState } from 'react'
import {Multiselect} from 'multiselect-react-dropdown'

//https://www.npmjs.com/package/multiselect-react-dropdown
//https://multiselect-react-dropdown.vercel.app/?path=/docs/multiselect-dropdown--flat-array
// const selectedData =[ 
//     {
//         "sub_id": 1,
//         "sub_name": "Physics"
//     },
//     {
//         "sub_id": 2,
//         "sub_name": "Chemistry"
//     },
//     {
//         "sub_id": 3,
//         "sub_name": "Maths"
//     },
//     {
//         "sub_id": 4,
//         "sub_name": "Biology"
//     },
//     {
//         "sub_id": 5,
//         "sub_name": "GK"
//     },
// ]
const customStyle={
    chips: {
      background: '#950202'
    },
    multiselectContainer: {
      
    },
    searchBox: {
      border: 'none',
      boxShadow: '0px 1px 4px rgb(0 0 0 / 8%)',
      background: '#ebe7e7'
    },
    placeholder:{
        color: '#000'
    }
  }

const MultiSelectDropdown = ({options,displayValue,onRemove,onSelect,selectedValues,placeholder,isObject,...rest}) => {
  //const [options] = useState(data)
//   const [state, setstate] = useState(selectedData);
// const selectfn = (selectedList) => {
//     setstate(selectedList)
//     console.log(state)
// }
// const removefn = (selectedList,selectedItem) => {
//     setstate(selectedList)
//     console.log(state)
// }

  return (
    <>
      {/* <Multiselect
        options={data}
        displayValue="sub_name"
        selectedValues={state}
        onSelect={selectfn}
        onRemove={removefn}
        closeIcon="cancel"
      /> */}
       <Multiselect
       isObject={isObject}
        options={options}
        displayValue={displayValue}
        selectedValues={selectedValues}
        onSelect={onSelect}
        onRemove={onRemove}
        closeIcon="cancel"
        placeholder={placeholder}
        style={customStyle}
        showArrow={true}
        {...rest}
      />
    </>
  );
}

export default MultiSelectDropdown